import React, { useEffect, useState } from "react";
import './ClientsList.scss';

const ClientsList = ({ setClient, currentClient, initialNumber, clientInfo }) => {
  const [removeAnimation, setRemoveAnimation] = useState(false);
  const handlerChooseCard = (id) => setClient(id);

  useEffect(() => {
    const closeAnimation = setTimeout(() => {
      setRemoveAnimation(true);
    }, 1500)

    return () => {
      clearTimeout(closeAnimation)
    }
  }, [])

  return (
    <div className="clients-list-wrapper">
      <div className="clients-list">
        {clientInfo?.map(({ id, logoUrl, p2, dark }) => (
          <div key={id} className="clients-list__client">
            <div className={`clients-list__client--card ${currentClient === id ? 'active' : ''} ${removeAnimation ? 'remove-anim' : ''}`}
                 onClick={() => handlerChooseCard(id)}>
              {currentClient === id && <div className="check-mark">&#10003;</div>}
              <img src={logoUrl} alt="client" className={`${p2 ? 'p-2' : ''} ${dark ? 'dark' : ''}`}/>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ClientsList;
